import React, { FC, memo } from 'react';
import { Button, Modal } from '~/shared/components';
import { useTranslation } from '~/shared/utils/translation';
import {
    connectStateResults,
    StateResultsProvided,
    connectCurrentRefinements,
} from 'react-instantsearch-core';
import styles from './filters-drawer.module.css';
import { DrawerFilters } from './drawer-filters/drawer-filters.component';

export const ClearButton = connectCurrentRefinements(({ items, refine }) => {
    const { translate } = useTranslation();
    return (
        <Button variant="secondary" onClick={() => refine(items)} disabled={!items.length}>
            {translate('commerce.filters.clearAll')}
        </Button>
    );
});

type Props = {
    isOpen: boolean;
    onClose: () => void;
} & StateResultsProvided;

const FiltersDrawerComponent: FC<Props> = memo((props) => {
    const { isOpen, onClose, searchResults } = props;
    const { translate } = useTranslation();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            variant="drawerRight"
            headline={translate('commerce.filters.filterBy')}
            headLineVariant='bodySm'
            removeBodyPadding
            className={styles.modal}
            scrollLock
            doNotRemoveContentFromDOMWhenClosed
            footer={
                <div className={styles.footerContent}>
                    <ClearButton />
                    <Button variant="primary" onClick={onClose}>
                        {translate('commerce.viewFilteredResults')}({searchResults?.nbHits})
                    </Button>
                </div>
            }
        >
            <DrawerFilters maxValuesPerFacet={100} />

            {/* <AccordionGroups maxValuesPerFacet={100} /> */}
        </Modal>
    );
});

FiltersDrawerComponent.displayName = 'FiltersDrawer';
export const FiltersDrawer = connectStateResults<Props>(FiltersDrawerComponent);
